import dayjs from 'dayjs';

// 给可序列化的值加上序号。value: 可序列化的值, order_fields: 序号字段名
// 使用this.$global_utils.AddOrderNumber(data)来调用方法
export function AddOrderNumber(value, order_fields='order_number') {
    for(let i in value){
        value[i][order_fields] = Number(i) + 1
    }
    return value
}

// 通过修改当前url, 来达到刷新效果。
// 使用this.$global_utils.RefreshPage.bind(this)()来用此方法
export function RefreshPage(){
    // 添加一个时间戳参数，确保每次跳转的fullPath不同
    console.log('Refresh successful')
    this.$router.push({query: {...this.$route.query, 'timestamp': Date.now()}})
}


// 当后端接口返回文件类型时, 从响应头获取文件名
// 使用this.$global_utils.GetDownloadFileName.bind(this)(response.headers, default_name)来用此方法. 
    // response.headers: 当文件请求时, 后端返回的response.headers, 
    // default_name: 如果没有获取到文件名时, 使用默认的文件名
export function GetDownloadFileName(response_headers, default_name){
    console.log('get download file_name')
    // 获取文件名
    const contentDisposition = response_headers['content-disposition'];
    let fileName = default_name;
    if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+)"?/);
        if (match) fileName = match[1];
    }
    return fileName
}


// 通过后端返回的bold, 然后在浏览器中下载
// 使用this.$global_utils.CreateDownload.bind(this)(response.data, file_name)来用此方法. response.data: 当文件请求时, 后端返回的response.data，file_name: 下载的文件名
export function CreateDownload(file_data, file_name){
    console.log('create download')
    // 创建下载链接
    const url = window.URL.createObjectURL(new Blob([file_data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', file_name);
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url)
}

// 判断字符串是否是可以转换为数字
// 使用this.$global_utils.StrIsNumber.bind(this)(number_str)来用此方法. 传入字符串, 返回对象(属性: is_number: 是否是数字, number: 转换后的number)
export function StrIsNumber(number_str){
    if(/^[-+]?\d+(\.\d*)?$/.test(number_str)){
        return {'is_number': true, 'number': Number(number_str)}
    }
    return {'is_number': false}
}



/**
 * Check if string a contains string b (case-insensitive)
 * Use this.$global_utils.is_include(str_a, str_b) to call this method.
 * str_a: the string to search in,
 * str_b: the substring to search for
 * If str_a or str_b is not of string type, they will be converted to strings before comparison
 * Return value: boolean, returns true if str_a contains str_b, otherwise returns false
 * @param str_a
 * @param str_b
 * @returns {boolean}
 */
export function is_include(str_a, str_b){
    if (!str_a) { return true }
    return str_b.toLowerCase().includes(str_a.toLowerCase())
}


/**
 * Remove a specified element from an array
 * Use this.$global_utils.remove_in_array(array, item) to call this method.
 * array: the source array from which to remove the element,
 * item: the element to remove from the array
 * If item is not in array, no operation will be performed
 * Return value: a new array with the specified element removed (the original array will not be modified)
 */
export function remove_in_array(array, item) {
    const item_filter = each => each !== item
    return array.filter(item_filter)
}


/**
 * Simple hash function for strings
 * Converts any string to a numeric hash value
 */
export function simple_hash(str) {
    let hash = 0;
    if (str.length === 0) return hash;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash; // Convert to 32-bit integer
    }
    return Math.abs(hash);
}


/**
 * Ensure input is converted to a Date object
 * Use this.$global_utils.ensure_date(input) to call this method.
 * input: can be a string (in various date formats) or a Date object
 * Returns a Date object, or null if the input cannot be converted to a valid date
 */
export function ensure_date(input) {
    // If input is already a Day.js object, return it directly (clone to avoid mutation issues)
    if (dayjs.isDayjs(input)) { return input.clone();
    }

    // If input is a Date object, convert to Day.js
    if (input instanceof Date) {
        return dayjs(input);
    }

    // If input is null or undefined, return null
    if (input == null) {
        return null;
    }

    // If input is a string, try to parse it as a date
    if (typeof input === 'string') {
        // Trim whitespace and check if empty
        const trimmed = input.trim();
        if (trimmed === '') {
            return null;
        }

        // Create a Day.js object from the string
        const date = dayjs(trimmed);

        // Check if the date is valid
        if (!date.isValid()) {
            return null;
        }

        return date;
    }

    // For other types (number, etc.), try to create a Day.js object
    const date = dayjs(input);
    if (!date.isValid()) {
        return null;
    }

    return date;
}


/**
 * Ensure input is converted to number (custom rule)
 *
 * Rules:
 * - true  -> 1
 * - false -> 0
 * - null / undefined -> 0
 * - valid number string -> number
 * - invalid -> 0
 */
export function ensure_number(input) {
    // Explicit rules first
    if (input === true) return 1;
    if (input === false || input === null || input === undefined) return 0;
    // Already a number
    if (typeof input === 'number') {
        return Number.isFinite(input) ? input : 0;
    }
    // String
    if (typeof input === 'string') {
        const trimmed = input.trim();
        if (trimmed === '') return 0;
        const num = Number(trimmed);
        return Number.isFinite(num) ? num : 0;
    }
    // Fallback for other types
    const num = Number(input);
    return Number.isFinite(num) ? num : 0;
}

